import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Grußkarten generieren", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "p-mb-4" }, " Mithilfe des Grußkarten Generators können personalisierte PDFs für die Grußkarten erstellt werden. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Steps = _resolveComponent("Steps")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_Steps, {
      model: _ctx.items,
      readonly: true,
      class: "p-mb-4"
    }, null, 8, ["model"]),
    _createVNode(_component_router_view)
  ], 64))
}